import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import { ReactComponent as ContactEmailIcon } from 'Assets/svg/contact-email.svg';
import { ReactComponent as OrganizationIcon } from 'Assets/svg/organization.svg';
import { ReactComponent as CopyIcon } from 'Assets/svg/copy.svg';
import ToolTipWithIcon from '../ToolTipWithIcon';
import ContactEmailScore from './contactEmailScore';
import ContactPhone from './ContactPhone';
import EmailVerificationMessage from '../emailVerificationMessage';

const NATextWithIcon = () => {
  return (
    <>
      <span>
        <i>- Not Available -</i>
      </span>
      <ToolTipWithIcon>
        Save to a list. You will be notified once we find the contact details.
      </ToolTipWithIcon>
    </>
  );
};

const ContactEmailPhone = observer(props => {
  const {
    contactId,
    email = '',
    phoneNumberFromVendor = null,
    isDownloaded = false,
    pageName = 'advsearch',
    purchaseContactFunc = null,
    status = '',
    score,
    currentPage,
    isEmailValid = true,
    purchaseMobile,
    showFindEmail,
  } = props;

  const isOwned = isDownloaded && email?.indexOf('*') === -1;

  const { featureFlags } = userDetail;
  const { COPY_RESTRICTION = false, PHONE_NUMBER = false } = featureFlags;

  const copyContactInfo = (e, id, isDownload, type) => {
    const str = e.currentTarget.getAttribute('data-value');
    e.preventDefault();
    if (isDownload || COPY_RESTRICTION === false) {
      Utils.copyToClipBoard(str);
      if (pageName === 'advsearch')
        Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_COPY_CLICKED, { type });
      else if (pageName === 'myleads')
        Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_COPY_CLICKED, { type });

      purchaseStatusPopupState.setToastMsg(null, null, null, true);
    }
  };

  const purchaseContactIfNotOwned = e => {
    if (e) e.preventDefault();
    if (!isOwned && purchaseContactFunc !== null)
      purchaseContactFunc(e, contactId);
  };

  return (
    <div className="contact-info">
      {showFindEmail &&
        (email !== null &&
        email !== undefined &&
        email !== '' &&
        (isEmailValid || isEmailValid === null) ? (
          <div className={`contact-email${isOwned ? ' owned' : ''}`}>
            <div className="info-icon">
              <ContactEmailIcon />
            </div>
            <div className="contact-email-copy-wrap">
              <div className="email-wrapper">
                <div
                  className={`info-detail show-elipsis ${
                    isOwned ? 'default-cursor' : ''
                  }`}
                  onClick={e => purchaseContactIfNotOwned(e)}
                >
                  {email}
                </div>
                {isOwned && (
                  <CopyIcon
                    className="copy-icon"
                    onClick={e =>
                      copyContactInfo(e, contactId, isOwned, 'email')
                    }
                    data-value={email}
                  />
                )}
                <ContactEmailScore
                  showFindEmail={showFindEmail}
                  score={score}
                  status={status}
                  currentPage={currentPage}
                />
              </div>
            </div>
          </div>
        ) : (
          <EmailVerificationMessage />
        ))}

      <ContactPhone
        pageName="advsearch"
        contactId={contactId}
        phone={phoneNumberFromVendor}
        purchaseMobile={purchaseMobile}
      />
    </div>
  );
});

export { ContactEmailPhone, NATextWithIcon };
export default ContactEmailPhone;
